"use client";

import { motion } from "motion/react";
import { FadeInUp } from "@/components/ui/motion";
import { DeveloperSection } from "../components/DeveloperSection";
import { Features } from "../components/Features";
import { FinalCTA } from "../components/FinalCTA";
import { HowItWorks } from "../components/HowItWorks";
import { Integrations } from "../components/Integrations";
import { ProblemSolution } from "../components/ProblemSolution";
import { Security } from "../components/Security";
import { WorkflowDemo } from "../components/WorkflowDemo";

const ProductPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <main className="pt-16">
        {/* Hero for Product page */}
        <section className="py-16 lg:py-24 relative overflow-hidden">
          {/* Background glow */}
          <div className="absolute top-20 left-1/4 w-[500px] h-[500px] bg-primary/8 rounded-full blur-[120px] pointer-events-none" />

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
            <FadeInUp className="max-w-3xl mx-auto text-center mb-12">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-6">
                Everything you need to{" "}
                <span className="gradient-text">automate</span>
              </h1>
              <p className="text-xl text-muted-foreground">
                Visual workflow builder with developer-grade observability.
                Build, debug, and scale your automations with confidence.
              </p>
            </FadeInUp>

            {/* Product preview */}
            <FadeInUp delay={0.2}>
              <div className="relative max-w-4xl mx-auto">
                <div className="absolute -inset-4 bg-primary/5 rounded-2xl blur-2xl" />
                <motion.div
                  className="relative bg-card rounded-xl border border-border shadow-xl overflow-hidden"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                >
                  <WorkflowDemo />
                </motion.div>
              </div>
            </FadeInUp>
          </div>
        </section>

        <ProblemSolution />
        <HowItWorks />
        <section id="features">
          <Features />
        </section>
        <Integrations />
        <section id="developers">
          <DeveloperSection />
        </section>
        <section id="security">
          <Security />
        </section>
        <FinalCTA />
      </main>
    </div>
  );
};

export default ProductPage;
